import cartMethods from '../../utils/helpers/cart-helper';
import { trackElementsVisibility } from '../../utils/observeElementOutOfViewport';
import { initTooltip } from './tooltip';
import { initProductImagesSlider } from './product-images';
import { getTagDiscount } from '../../utils/discount';
import { exists } from '../../../new/utils/data-safety';
import { openBackInStackModal } from '../../utils/bis';
import { EVENTS } from '../../../new/vue/cart/constants';

const { post } = cartMethods;

const currencySymbol = window.BPN?.shop?.currency?.symbol || window.BPN?.cart?.currencySymbol || '$';

let domCache = {};

const getFormattedPrice = (price, tagDiscount) => {
  if (tagDiscount) {
    return `${currencySymbol}${(price * (1 - tagDiscount / 100) / 100).toFixed(2)}`;
  }

  return `${currencySymbol}${(price / 100).toFixed(2)}`;
};

const updatePrice = (variation) => {
  const tagDiscount = getTagDiscount(domCache.product.tags);
  const { product_price: price } = variation.dataset;
  const buyBoxOTPPriceContainers = document.querySelectorAll('.buy-box__one-time-purchase .buy-box__purchase-type-price');
  const buyBoxSubscriptionPriceContainers = [ ...document.querySelectorAll('.buy-box__subscription .buy-box__purchase-type-price') ];
  const discountContainers = document.querySelectorAll('.buy-box__subscription .buy-box__purchase-type-discount');

  const formattedPrice = getFormattedPrice(price, tagDiscount);

  buyBoxOTPPriceContainers.forEach((item) => {
    item.innerHTML = formattedPrice;
  });

  buyBoxSubscriptionPriceContainers.map((buyBoxSubscriptionPriceContainer, index) => {
    const discount = Number(buyBoxSubscriptionPriceContainer.dataset.discount) || 15;
    const discountedPrice = (price - (price / 100 * discount)).toFixed(2);

    if (tagDiscount) {
      buyBoxSubscriptionPriceContainer.innerHTML = formattedPrice;
    } else {
      buyBoxSubscriptionPriceContainer.innerHTML = `${currencySymbol}${(discountedPrice / 100).toFixed(2)}`;
    }

    if (discountContainers[index]) {
      if (tagDiscount) {
        discountContainers[index].innerHTML = `Save ${tagDiscount}%`;
      } else {
        discountContainers[index].innerHTML = `Save ${currencySymbol}${((price - discountedPrice) / 100).toFixed(2)}`;
      }
    }
  });
};

const selectVariationInCurrentProductDataById = (variationId) => {
  return domCache.product.variants.find(item => String(item.id) === String(variationId));
};

const selectVariationById = (variationId) => {
  return domCache.product.variants.find(item => String(item.id) === String(variationId));
};

const selectUnavailableVariations = () => {
  return domCache.product.variants.filter(item => item.available === false || item.availability === 'oos');
};

const shouldBeVisible = (selectedOption, option) => {
  const { position: sPosition, value: sValue, variation_id: sVariationId } = selectedOption.dataset;
  const { position, value, variation_id: variationId } = option.dataset;

  const variation = selectVariationById(variationId);
  const selectedVariation = selectVariationById(sVariationId);

  if (sPosition === position) {
    const expectedOption = selectedVariation.options.filter((option) => option !== sValue);

    return sValue !== value && expectedOption.every((option) => variation.options.includes(option));
  }

  const options = option.closest('.selector-container').dataset.options.split(',');

  const allowedOption = [ ...options, ...selectedVariation.options ];

  return variation.options.every(option => allowedOption.includes(option));
};

const shouldBeSelected = (selectedOption, option) => {
  const { position: sPosition, value: sValue, variation_id: sVariationId } = selectedOption.dataset;
  const { position, variation_id: variationId } = option.dataset;

  if (sPosition === position) {
    return false;
  }

  const variation = domCache.product.variants.find(item => String(item.id) === String(variationId));
  const selectedVariation = domCache.product.variants.find(item => String(item.id) === String(sVariationId));
  const allowedOption = selectedVariation.options.filter((item) => item !== sValue);

  return allowedOption.every(option => variation.options.includes(option));
};

const syncCarousel = (element) => {
  const variation = selectVariationById(element.dataset.variation_id);
  const carousel = document.querySelector('.product-images-carousel');
  const title = variation.title.toLowerCase();
  const productTitle = domCache.product.title.toLowerCase();

  if (carousel) {
    carousel.querySelectorAll('.image-slide').forEach(slide => {
      let show = slide.dataset.alt.includes(title) || slide.dataset.alt.includes(productTitle) || slide.dataset.alt.includes('@common');
      // fixed a specific issue with Go Gel Variants where variant names are similar
      show = slide.dataset.alt.includes('caf') && !title.includes('caf') ? false : show;
      if (show) {
        slide.classList.remove('hidden');
      } else {
        slide.classList.add('hidden');
      }
    });
  }

  domCache.swipers.forEach((swiper) => {
    swiper.slideTo(0);
    swiper.update();
  });
};

const isSubscriptionEnabled = () => {
  return document.querySelectorAll('.buy-box__purchase-type.buy-box__subscription.selected').length !== 0;
};

const syncNutritionFacts = (variant) => {
  const variationId = variant.dataset.variation_id;
  const id = `nutrition-facts-${variationId}`;
  const facts = document.querySelectorAll('.nutrition-facts');

  facts.forEach((fact) => {
    if (fact.classList.contains(id)) {
      fact.classList.remove('hidden');
    } else {
      fact.classList.add('hidden');
      fact.classList.remove('active');
    }
  });
};

const syncOptions = (selectedOption) => {
  const variationId = selectedOption.dataset.variation_id;

  domCache.selectors.forEach((option) => {
    if (option === selectedOption || option.dataset.variation_id === variationId) {
      option.classList.add('selected');
      option.classList.remove('hidden');
    } else {
      if (shouldBeVisible(selectedOption, option)) {
        option.classList.remove('hidden');
      } else {
        option.classList.add('hidden');
      }

      if (shouldBeSelected(selectedOption, option)) {
        option.classList.add('selected');
      } else {
        option.classList.remove('selected');
      }
    }
  });

};

const syncDropdownTriggerLabel = () => {
  document.querySelectorAll('.product-hero__dropdown-trigger .sold-out-label').forEach(label => label.parentNode.removeChild(label));
};

const syncCTALabel = (price) => {
  const tagDiscount = getTagDiscount(domCache.product.tags);
  const formattedPrice = getFormattedPrice(price, tagDiscount);
  const comparePrice = getFormattedPrice(price);

  const priceContainer = document.querySelector('.product-hero__price');

  const isChecked = domCache.pairProductCheckbox?.checked;

  let modalButtonText = `ADD TO CART - ${formattedPrice}`;
  let ctaButtonText = modalButtonText;

  if(priceContainer) {
    if(!tagDiscount) {
      priceContainer.innerHTML = formattedPrice;
    }
  }

  if (isSubscriptionEnabled() && !isChecked) {
    const buyBoxSubscriptionPriceContainer = document.querySelector('.buy-box__subscription .buy-box__purchase-type-price');
    const discount = Number(buyBoxSubscriptionPriceContainer.dataset.discount) || 15;
    const discountedPrice = (price - (price / 100 * discount)).toFixed(2);

    if(!tagDiscount) {
      modalButtonText = `ADD TO CART - <span class="compare-price">${comparePrice}</span> ${`${currencySymbol}${(discountedPrice / 100).toFixed(2)}`}`;
      if(priceContainer) {
        priceContainer.innerHTML = `${currencySymbol}${(discountedPrice / 100).toFixed(2)}`;
      }
    } else {
      modalButtonText = `ADD SUBSCRIPTION TO CART - ${tagDiscount ? formattedPrice : `${currencySymbol}${(discountedPrice / 100).toFixed(2)}`}`;
    }
    ctaButtonText = modalButtonText;
  }


  if (isChecked) {
    modalButtonText = `Add Both To Cart - ${formattedPrice}`;
    ctaButtonText = modalButtonText;
  }

  if (!domCache.addProductButton.disabled) {
    domCache.addProductButton.innerHTML = ctaButtonText;
    domCache.modalAddProductButton.forEach((button) => {
      button.innerHTML = modalButtonText;
    });
  }
};

const syncDeliveryFrequencyVisibility = () => {
  const bullet = domCache.baseInformation.querySelector('.bullet');
  const deliveryFrequency = domCache.baseInformation.querySelector('.delivery-frequency');

  if (isSubscriptionEnabled()) {
    deliveryFrequency.classList.remove('hidden');

    if (bullet) {
      bullet.classList.remove('hidden');
    }
  } else {
    deliveryFrequency.classList.add('hidden');

    if (bullet) {
      bullet.classList.add('hidden');
    }
  }
};

const syncModalFlavorOption = (value) => {
  const label = document.querySelector('.flavor-option');

  if (label) {
    label.innerHTML = value;
  }
};

const toggleSubscriptionVisibility = (showSubscription = false) => {
  const elements = document.querySelectorAll('.subscription-selector');

  elements.forEach((element) => {
    if (showSubscription) {
      element.classList.remove('opacity-hidden');
    } else {
      element.classList.add('opacity-hidden');
    }
  });
};

const getExternalUrl = (variant) => {
  if (typeof variant['external_link'] !== 'undefined' && 'url' in variant.external_link) {
    return [ variant.external_link.text, variant.external_link.url ];
  }

  return '';
};

const toggleQuantitySelectorVisibility = (show) => {
  if (domCache.quantitySelector) {
    if (show) {
      domCache.quantitySelector.classList.remove('hidden');
    } else {
      domCache.quantitySelector.classList.add('hidden');
    }
  }
};

function syncCTA(item) {
  const { variation_id: variationId, available, product_price: price } = item.dataset;
  const variant = selectVariationInCurrentProductDataById(variationId);
  const { availability = 'default' } = variant;

  domCache.addProductButton.setAttribute('data-variation_id', variationId);
  domCache.modalAddProductButton.forEach((button) => {
    button.setAttribute('data-variation_id', variationId);
  });
  syncCTALabel(price);
  syncDropdownTriggerLabel();

  if (availability === 'external') {
    const [ text, url ] = getExternalUrl(variant);

    domCache.externalLink.setAttribute('href', url);
    domCache.externalLink.innerHTML = text;

    domCache.modalExternalLink.setAttribute('href', url);
    domCache.modalExternalLink.innerHTML = text;

    // external
    domCache.externalLink.classList.remove('hidden');
    domCache.modalExternalLink.classList.remove('hidden');

    // add
    domCache.addProductButton.classList.add('hidden');
    domCache.modalAddProductButton.forEach((button) => {
      button.classList.add('hidden');
    })

    // oos
    domCache.bisTriggers.forEach(el => el.classList.add('hidden'));
    domCache.modalBisTriggers.forEach(el => el.classList.add('hidden'));

    toggleSubscriptionVisibility(false);
    toggleQuantitySelectorVisibility(false);
    return;
  }

  if (availability === 'oos' || available === false) {
    // external
    domCache.externalLink.classList.add('hidden');
    domCache.modalExternalLink.classList.add('hidden');

    // add
    domCache.addProductButton.classList.add('hidden');
    domCache.modalAddProductButton.forEach((button) => {
      button.classList.add('hidden');
    })

    // oos
    domCache.bisTriggers.forEach(el => el.classList.remove('hidden'));
    domCache.modalBisTriggers.forEach(el => el.classList.remove('hidden'));

    toggleSubscriptionVisibility(false);
    toggleQuantitySelectorVisibility(false);

    return;
  }

  // add
  domCache.addProductButton.classList.remove('hidden');
  domCache.modalAddProductButton.forEach((button) => {
    button.classList.remove('hidden');
  })

  // oos
  domCache.bisTriggers.forEach(el => el.classList.add('hidden'));
  domCache.modalBisTriggers.forEach(el => el.classList.add('hidden'));

  // external
  domCache.externalLink.classList.add('hidden');
  domCache.modalExternalLink.classList.add('hidden');

  toggleSubscriptionVisibility(true);
  toggleQuantitySelectorVisibility(true);
}

const initSelector = (selector) => {
  const variations = selector.querySelectorAll('.variation-option');

  if (variations.length === 1) {
    return;
  }

  variations.forEach(variation => {
    variation.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();

      syncCTA(variation);
      updatePrice(variation);
      syncOptions(variation);
      syncNutritionFacts(variation);
      syncCarousel(variation);

      return false;
    });
  });
};

const updateVariationDropdownLabels = (value) => {
  document.querySelectorAll('.product-hero__dropdown button span').forEach(label => {
    label.innerHTML = value;
  });
};

const initVariationDropdown = (dropdown) => {
  const dropdownTrigger = dropdown.querySelector('.product-hero__dropdown-trigger');
  const variations = dropdown.querySelectorAll('.product-hero__dropdown-item');

  const outClickHandler = (event) => {
    if (!dropdown.contains(event.target)) {
      event.preventDefault();
      event.stopPropagation();

      dropdown.classList.remove('active');

      return false;
    }
  };

  const selectValidation = (variation) => {
    dropdown.classList.remove('active');

    const flavor = variation.dataset.value;

    updateVariationDropdownLabels(variation.innerHTML);
    syncCTA(variation);
    updatePrice(variation);
    syncOptions(variation);
    syncCarousel(variation);
    syncNutritionFacts(variation);
    if (variation.dataset.value) {
      syncModalFlavorOption(flavor);
    }
  };

  const openDropdown = (event) => {
    event.preventDefault();
    event.stopPropagation();

    if (dropdown.classList.contains('active')) {
      dropdown.classList.remove('active');
    } else {
      dropdown.classList.add('active');
      document.addEventListener('click', outClickHandler, { capture: true, once: true });
    }

    return false;
  };

  variations.forEach(variation => variation.addEventListener('click', () => selectValidation(variation)));

  if (dropdownTrigger) {
    dropdownTrigger.addEventListener('click', openDropdown);
  }
};

const updateDropdownTriggerLabel = (value) => {
  const dropdownTriggerLabels = document.querySelectorAll('.delivery-type-dropdown button span');
  const deliveryFrequencyLabel = document.querySelector('#delivery-frequency');

  deliveryFrequencyLabel.innerHTML = value;

  dropdownTriggerLabels.forEach((dropdownTriggerLabel) => {
    dropdownTriggerLabel.innerHTML = value;
  });
};

const initSubscriptionSelector = () => {
  const selectors = document.querySelectorAll('.buy-box__purchase-type');

  selectors.forEach(selector => selector.addEventListener('click', () => {
    const isSubscriptionItem = selector.classList.contains('buy-box__subscription');

    selectors.forEach((item) => {
      if (isSubscriptionItem) {
        if (item.classList.contains('buy-box__subscription')) {
          item.classList.add('selected');
        } else {
          item.classList.remove('selected');
        }
      } else {
        if (!item.classList.contains('buy-box__subscription')) {
          item.classList.add('selected');
        } else {
          item.classList.remove('selected');
        }
      }

      const { variation_id: variationId } = domCache.addProductButton.dataset;
      const variation = domCache.product.variants.find(item => String(item.id) === String(variationId));

      syncCTALabel(variation.price);
      syncDeliveryFrequencyVisibility();
    });
  }));

};

const initDeliveryTypeDropdown = (dropdown) => {
  const trigger = dropdown.querySelector('.delivery-type-dropdown__trigger');

  const values = document.querySelectorAll('.delivery-type-dropdown__dropdown-item');

  const outClickHandler = (event) => {
    if (!dropdown.contains(event.target)) {
      event.preventDefault();
      event.stopPropagation();

      dropdown.classList.remove('active');

      return false;
    }
  };
  const openDropdown = (event) => {
    event.preventDefault();
    event.stopPropagation();

    if (dropdown.classList.contains('active')) {
      dropdown.classList.remove('active');
    } else {
      dropdown.classList.add('active');
      document.addEventListener('click', outClickHandler, { capture: true, once: true });
    }

    return false;
  };

  const selectValue = (event) => {
    event.preventDefault();
    event.stopPropagation();

    const { selling_plan: selectedSellingPlan } = event.currentTarget.dataset;

    domCache.addProductButton.setAttribute('data-selling_plan', selectedSellingPlan);
    domCache.modalAddProductButton.forEach((button) => {
      button.setAttribute('data-selling_plan', selectedSellingPlan);
    })

    values.forEach(element => {
      const { selling_plan: sellingPlan } = element.dataset;

      if (selectedSellingPlan === sellingPlan) {
        updateDropdownTriggerLabel(event.currentTarget.innerHTML);

        element.classList.add('selected');
      } else {
        element.classList.remove('selected');
      }
    });

    dropdown.classList.remove('active');

    return false;
  };

  if (trigger) {
    trigger.addEventListener('click', openDropdown);
  }

  values.forEach(variation => variation.addEventListener('click', selectValue));
};

const initInformationAccordion = () => {
  document.querySelectorAll('.information-accordion').forEach((accordion) => {
    const accordionItems = accordion.querySelectorAll('.information-accordion__item');

    accordionItems.forEach(accordionItem => {
      accordionItem.addEventListener('click', () => {
        accordionItems.forEach(item => {
          if (item === accordionItem) {
            item.classList.toggle('active');
          } else {
            item.classList.remove('active');
          }
        });
      });
    });
  });
};

const initQuantitySelector = () => {
  if (!domCache.quantitySelector) {
    return;
  }

  const valueElement = domCache.quantitySelector.querySelector('.quantity-selector__value');
  const prevElement = domCache.quantitySelector.querySelector('.quantity-selector__control');

  const updateQuantity = (newQuantity) => {
    valueElement.innerText = newQuantity;
    domCache.addProductButton.setAttribute('data-quantity', String(newQuantity));
    domCache.modalAddProductButton.forEach((button) => {
      button.setAttribute('data-quantity', String(newQuantity));
    });

    if (newQuantity === 1) {
      prevElement.classList.add('disabled');
      prevElement.disabled = true;
    } else {
      prevElement.classList.remove('disabled');
      prevElement.disabled = false;
    }
  };

  domCache.quantitySelector.addEventListener('click', (event) => {
    const { direction } = event.target.dataset;
    const actualValue = Number(valueElement.innerText);

    if (!direction) {
      return;
    }

    if (direction === 'prev' && !prevElement.classList.contains('disabled')) {
      updateQuantity(actualValue - 1);
    } else if (direction === 'next') {
      updateQuantity(actualValue + 1);
    }
  });
};

const showStickyFooter = () => {
  domCache.stickyFooter.classList.remove('hidden');
};

const hideStickyFooter = () => {
  domCache.stickyFooter.classList.add('hidden');
};

const initAddCartChangeOptions = () => {
  const elements = [
    domCache.addProductButton,
    domCache.externalLink,
    ...domCache.bisTriggers,
  ].filter(Boolean);
  domCache.addCartChangeOptions.forEach((button) => {
    button.addEventListener('click', () => {
      domCache.addToCardBuyBox.classList.toggle('hidden');
      domCache.iconChevronDown?.classList.toggle('rotated')
    });
  })

  if (!domCache.addToCardBuyBox) return;

  domCache.addToCardBuyBox.addEventListener('click', (event) => {
    if (event.target === domCache.addToCardBuyBox) {
      domCache.addToCardBuyBox.classList.toggle('hidden');
      domCache.iconChevronDown?.classList.toggle('rotated')
    }
  });

  trackElementsVisibility(elements, hideStickyFooter, showStickyFooter);

  domCache.closeAddToCartModal.addEventListener('click', () => {
    domCache.addToCardBuyBox.classList.toggle('hidden');
  });
};

const addProduct = async (event) => {
  event.preventDefault();
  event.stopPropagation();

  const { variation_id, selling_plan = undefined, quantity = 1 } = event.target.dataset;

  const payload = { id: parseInt(variation_id), quantity };

  if (isSubscriptionEnabled() && selling_plan) {
    payload.selling_plan = selling_plan;
  }

  await post('add', payload);

  domCache.addToCardBuyBox.classList.add('hidden');

  if (domCache.pairProductCheckbox?.checked) {
    const pairVariantId = domCache.pairProductCheckbox.dataset.variant_id;
    const pairPayload = { id: parseInt(pairVariantId), quantity: '1' };
    setTimeout(async() => {
      try {
        await post('add', pairPayload);
        document.dispatchEvent(new CustomEvent(EVENTS.ITEM_ADDED, {
          detail: { id: pairPayload.id },
        }));
      } catch(error) {
        console.error('Failed to add pair product:', error);
      }
    }, 1000)
  }

  document.dispatchEvent(new CustomEvent(EVENTS.ITEM_ADDED, {
    detail: { id: payload.id },
  }));

  return null;
};

const openBISModal = (event) => {
  event.stopPropagation();

  const { product_id, variation_id } = domCache.addProductButton.dataset;

  const variation = selectVariationById(variation_id);

  let unavailableVariations = selectUnavailableVariations();

  if (unavailableVariations.length === 0) {
    unavailableVariations = [ variation ];
  }

  const product = {
    productId: product_id,
    handle: domCache.product.handle,
    title: domCache.product.shopify_title,
    variantId: variation.id,
    variantTitle: variation.title,
    variants: unavailableVariations,
  };

  openBackInStackModal(product);

  return false;
};

const initBISButtons = () => {
  domCache.bisTriggers.forEach((trigger) => {
    trigger.addEventListener('click', openBISModal, { capture: true });
  });

  domCache.modalBisTriggers.forEach((trigger) => {
    trigger.addEventListener('click', openBISModal, { capture: true });
  });
};

const initPairProductCheckbox = () => {
  if (!domCache.pairProductCheckbox) return;

  domCache.pairProductCheckbox.addEventListener('change', () => {
    const { variation_id: variationId } = domCache.addProductButton.dataset;
    const variant = selectVariationById(variationId);

    if (variant) {
      syncCTALabel(variant.price);
    }
  });
};

const makeAllSvgPatternsUnique = () => {
  let counter = 0;
  document.querySelectorAll('.product-hero__dropdown svg').forEach((svg, index) => {
    const pattern = svg.querySelector('pattern');
    if (pattern) {
      const oldId = pattern.getAttribute('id');
      const uniqueId = `${oldId}-${counter++}`;

      // Update the pattern ID
      pattern.setAttribute('id', uniqueId);

      // Update all references to this pattern (fill, stroke, etc.)
      svg.querySelectorAll(`[fill="url(#${oldId})"]`).forEach(el => {
        el.setAttribute('fill', `url(#${uniqueId})`);
      });
      svg.querySelectorAll(`[stroke="url(#${oldId})"]`).forEach(el => {
        el.setAttribute('stroke', `url(#${uniqueId})`);
      });
    }
  });
};

const initDom = () => {
  domCache.product = window.BPN.currentProductData;
  domCache.stickyFooter = document.querySelector('#add-to-cart-sticky-footer');
  domCache.addToCardBuyBox = document.querySelector('#add-to-cart-buy-box');
  domCache.addCartChangeOptions = document.querySelectorAll('.pdp-sticky-footer__change-options');
  domCache.bisTriggers = document.querySelectorAll('.buy-box-container #BIS_trigger');
  domCache.externalLink = document.querySelector('.buy-box-container .external_link');
  domCache.modalBisTriggers = document.querySelectorAll('.add-to-cart #BIS_trigger');
  domCache.modalExternalLink = document.querySelector('.add-to-cart .external_link');
  domCache.addProductButton = document.querySelector('.buy-box__add-button');
  domCache.modalAddProductButton = document.querySelectorAll('.add-to-cart__add-button');
  domCache.selectors = document.querySelectorAll('.variation-option');
  domCache.deliverDropdowns = document.querySelectorAll('.delivery-type-dropdown');
  domCache.quantitySelector = document.querySelector('.product-hero .quantity-selector');
  domCache.baseInformation = document.querySelector('.pdp-sticky-footer__variant-info');
  domCache.closeAddToCartModal = document.querySelector('.close-add-to-cart svg');
  domCache.swipers = initProductImagesSlider();
  domCache.pairProductCheckbox = document.querySelector('#pair-product-checkbox');
  domCache.iconChevronDown = document.querySelector('.pdp-sticky-footer__options-toggle .icon-chevron-down');
};

export const initBuyBox = () => {
  initDom();
  makeAllSvgPatternsUnique();
  const dropdowns = document.querySelectorAll('.product-hero__dropdown');
  const selectors = document.querySelectorAll('.product .selector-container .selector');

  dropdowns.forEach(dropdown => initVariationDropdown(dropdown));
  selectors.forEach(selector => initSelector(selector));

  domCache.addProductButton.addEventListener('click', addProduct);
  domCache.modalAddProductButton.forEach((button) => {
    button.addEventListener('click', addProduct);
  })

  domCache.deliverDropdowns.forEach(dropdown => initDeliveryTypeDropdown(dropdown));

  initSubscriptionSelector();
  initInformationAccordion();
  initQuantitySelector();
  initAddCartChangeOptions();
  initTooltip();
  initBISButtons();
  initPairProductCheckbox();
};
